import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { ClientAddressesManager } from './ClientAddressesManager';

export interface ClientAddressesDialogProps {
  open: boolean;
  clientId: number | null;
  clientName?: string;
  onClose: () => void;
}

export function ClientAddressesDialog({
  open,
  clientId,
  clientName,
  onClose,
}: ClientAddressesDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {clientName
          ? t('features.clientes.enderecos.dialogTitleNamed', { nome: clientName })
          : t('features.clientes.enderecos.dialogTitle')}
        <IconButton onClick={onClose} aria-label={t('common.close')} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {clientId !== null && <ClientAddressesManager clientId={clientId} />}
      </DialogContent>
    </Dialog>
  );
}
